module.exports = __webpack_public_path__ + "img/063-japan.ce5fd254.svg";